
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Product } from "@/types";
import { format } from "date-fns";
import { fr } from "date-fns/locale";

interface ProductsTableProps {
  products: Product[];
  onEditProduct: (product: Product) => void;
  onDeleteProduct: (product: Product) => void;
}

const ProductsTable = ({ products, onEditProduct, onDeleteProduct }: ProductsTableProps) => {
  return (
    <Card>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b bg-muted/50">
                <th className="text-left py-3 px-4 font-medium">Produit</th>
                <th className="text-left py-3 px-4 font-medium">Adresse IP</th>
                <th className="text-left py-3 px-4 font-medium">Email principal</th>
                <th className="text-left py-3 px-4 font-medium">Date d'expiration</th>
                <th className="text-left py-3 px-4 font-medium">Statut</th>
                <th className="text-right py-3 px-4 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product.id} className="border-b hover:bg-muted/30">
                  <td className="py-3 px-4">{product.name}</td>
                  <td className="py-3 px-4">{product.ipAddress}</td>
                  <td className="py-3 px-4">{product.primaryEmail}</td>
                  <td className="py-3 px-4">
                    {format(new Date(product.expirationDate), 'dd MMMM yyyy', { locale: fr })}
                  </td>
                  <td className="py-3 px-4">
                    <span className={`px-2 py-1 text-xs rounded-full ${
                      product.status === 'active'
                        ? 'bg-green-100 text-green-800'
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {product.status === 'active' ? 'Actif' : 'Expiré'}
                    </span>
                  </td>
                  <td className="py-3 px-4 text-right">
                    <Button 
                      variant="ghost" 
                      size="sm"
                      onClick={() => onEditProduct(product)}
                    >
                      Modifier
                    </Button>
                    <Button 
                      variant="ghost" 
                      size="sm" 
                      className="text-destructive"
                      onClick={() => onDeleteProduct(product)}
                    >
                      Supprimer
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
};

export default ProductsTable;
